import { useContext } from 'react';

// project imports
import { OfflineContext } from 'contexts/OfflineContext';

// ==============================|| USE ONLINE STATUS HOOK ||============================== //

/**
 * Hook to access offline/online status and related utilities
 *
 * @returns {Object} Offline context values
 * @property {boolean} isOnline - Whether the device is currently online
 * @property {boolean} isOfflineReady - Whether offline mode is available (data has been cached)
 * @property {number} unsyncedCount - Number of entries waiting to be synced
 * @property {boolean} isSyncing - Whether sync is currently in progress
 * @property {string|null} lastSyncTime - ISO timestamp of last successful sync
 * @property {string|null} syncError - Last sync error message if any
 * @property {Object|null} offlineUser - Cached user data for offline mode
 * @property {boolean} dbInitialized - Whether IndexedDB is initialized
 * @property {Function} refreshUnsyncedCount - Refresh the unsynced entries count
 * @property {Function} syncOfflineData - Sync all offline data to server
 * @property {Function} cacheDataForOffline - Cache data for offline use
 * @property {Function} checkOfflineReady - Check if offline mode is ready
 * @property {Function} setOfflineUser - Set the offline user session
 * @property {Function} clearOfflineSession - Clear the offline session
 */
const useOnlineStatus = () => {
  const context = useContext(OfflineContext);

  if (!context) {
    throw new Error('useOnlineStatus must be used within an OfflineProvider');
  }

  return context;
};

export default useOnlineStatus;
